import { Routes, Route, Navigate } from 'react-router-dom';
import { AppShell } from './components/AppShell.js';
import { ApprenantDetailPage } from './domains/apprenants/pages/ApprenantDetailPage.js';
import { ApprenantsIndexPage } from './domains/apprenants/pages/ApprenantsIndexPage.js';
import { CommunicationsPage } from './domains/communications/pages/CommunicationsPage.js';
import { DocumentsPage } from './domains/documents/pages/DocumentsPage.js';
import { FormsPage } from './domains/forms/pages/FormsPage.js';
import { EmargementsPage } from './domains/emargements/pages/EmargementsPage.js';
import { EspaceFormateurPage } from './domains/emargements/pages/EspaceFormateurPage.js';
import { ContratsFormateursPage } from './domains/contractualisation/pages/ContratsFormateursPage.js';
import { FormateursPage } from './domains/formateurs/pages/FormateursPage.js';

/**
 * App V2 — Refonte progressive du cockpit selon le pattern
 * Domain-Driven + Composition de slices.
 *
 * Routes :
 *  - /apprenants            → index (redirige vers dernier ID consulté ou message)
 *  - /apprenants/:id        → fiche détail
 *  - /communications        → page placeholder communications
 *  - /documents             → page placeholder documents
 *  - /forms                 → page placeholder formulaires
 *  - *                      → fallback /apprenants
 */
export default function App() {
  return (
    <AppShell>
      <Routes>
        <Route path="/apprenants" element={<ApprenantsIndexPage />} />
        <Route path="/apprenants/:id" element={<ApprenantDetailPage />} />
        <Route path="/communications" element={<CommunicationsPage />} />
        <Route path="/documents" element={<DocumentsPage />} />
        <Route path="/forms" element={<FormsPage />} />
        <Route path="/emargements" element={<EmargementsPage />} />
        <Route path="/emargements/formateur/:id" element={<EspaceFormateurPage />} />
        <Route path="/settings/contrats-formateurs" element={<ContratsFormateursPage />} />
        <Route path="/settings/formateurs" element={<FormateursPage />} />
        <Route path="/settings" element={<Navigate to="/settings/formateurs" replace />} />
        {/* Fallback : on tombe sur l'index Apprenants (qui redirige intelligemment) */}
        <Route path="*" element={<Navigate to="/apprenants" replace />} />
      </Routes>
    </AppShell>
  );
}
